import Feature26_morph_left from './Feature26_morph_left'
export default Feature26_morph_left
